export default {
  rootPath: '/',
  wellSupportingFileDocumentViewerPath:
    '/wells/:wellId/supporting_files/:documentId',
  documentsPath: '/documents',
  interpretationsPath: '/interpretations',
  courthouseDocumentPath: '/courthouse_documents/:id',
  nonCourthouseDocumentPath: '/non_courthouse_documents/:id',
  regulatoryDocumentPath: '/regulatory_documents/:id',
  afeDocumentPath: '/afe_documents/:id',
  divisionOrderDocumentPath: '/division_order_documents/:id',
  royaltyCheckDocumentPath: '/royalty_check_documents/:id',
  newDocumentsPath: '/documents/new',
  documentPath: '/documents/:id',
  documentInterpretationsPath: '/documents/:documentId/interpretations',
  documentInterpretationPath: '/documents/:documentId/interpretations/:id',
  newDocumentInterpretationPath: '/documents/:documentId/interpretations/new',
  activitiesPath: '/activities',
  wellsPath: '/wells',
  wellPath: '/wells/:id',
  wellWorkspacePath: '/well_workspaces/:id',
  developmentAreasPath: '/development_areas',
  developmentAreaPath: '/development_areas/:id',
  referenceLocationsPath: '/reference_locations',
  referenceLocationPath: '/reference_locations/:id',
  titleWorkspacesPath: '/title_workspaces',
  titleWorkspacePath: '/title_workspaces/:id',
  titleWorkspaceDocumentsPath: '/title_workspaces/:id/documents',
  titleWorkspaceWellsPath: '/title_workspaces/:id/wells',
  titleWorkspaceStartingInterestPath:
    '/title_workspaces/:titleWorkspaceId/starting_interest',
  titleWorkspaceRunsheetPath: '/title_workspaces/:id/runsheet',
  titleWorkspaceRunsheetTimelinePath: '/title_workspaces/:id/timeline',
  titleSupportWorkspacesPath: '/title_support_workspaces',
  titleSupportWorkspaceNewPath: '/title_support_workspaces/new',
  titleSupportWorkspacePath: '/title_support_workspaces/:id',
  interestCertificationWorkspacePath: '/interest_certification/workspaces/:id',
  titleChainCalculatorPath: '/title_chain_calculator',
  titleValidatorsPath: '/documents/:documentId/title_validators',
  newEntityPath: '/entities/new',
  entitiesPath: '/entities',
  entityPath: '/entities/:id',
  packagePath: '/packages/:id',
  // Eval 2 entry (INS-11484): the version switcher points "Eval 2" here; the shell
  // redirects it to the first evaluation (bare `/packages/:id` now lands on Eval 3).
  packageEvaluationsPath: '/packages/:id/evaluations',
  // INS-11484: the NEW Eval 3.0 page now owns the canonical `/eval3*` namespace and
  // the legacy page moved to `/eval3-legacy*`. Only the path VALUES swapped — the key
  // names (`packageEval3New*` = new page, `packageEval3Path`/`RunPath` = legacy) were
  // kept to avoid churn across every call site, so the names read one generation behind
  // their paths.
  packageEval3Path: '/packages/:id/eval3-legacy',
  packageEval3RunPath: '/packages/:id/eval3-legacy/:calcId',
  packageEval3NewPath: '/packages/:packageId/eval3',
  packageEval3NewWorkspacePath:
    '/packages/:packageId/eval3/workspaces/:workspaceId',
  packageEval3NewEvalPath:
    '/packages/:packageId/eval3/workspaces/:workspaceId/eval/:evalId',
  packageEval3NewSavedEvalsPath: '/packages/:packageId/eval3/saved-evals',
  scenariosPath: '/scenarios',
  newScenarioPath: '/scenarios/new',
  scenarioPath: '/scenarios/:id',
  compareWizardPath: '/packages/compare',
  compareResultPath: '/packages/compare/result',
  // Analyze Value Drivers (INS-11749) — the eval-3-vs-eval-3 NPV comparison launched
  // from the Package Comparison result page. Distinct from the NRI/WI compare above.
  compareAnalyzePath: '/packages/compare/analyze',
  compareAnalyzeFactorOrderPath: '/packages/compare/analyze/factor-order',
  compareAnalyzeResultsPath: '/packages/compare/analyze/results',
  packagesPath: '/packages',
  newPackagePath: '/packages/new',
  editPackagePath: '/packages/:id/edit',
  energyLinkPath: '/energy_link',
  energyLinkAccountsPath: '/energy_link/accounts',
  energyLinkNewAccountPath: '/energy_link/accounts/new',
  structureGridsPath: '/structure_grids',
  typeCurveFormationsPath: '/type_curve_formations',
  formationManagementPath: '/formation_management',
  typeCurvesPath: '/type_curves',
  typeCurvePath: '/type_curves/:id',
  typeCurveHeaderDetailsPath: '/type_curve_headers/:id',
  addStructureGridPath: '/add_structure_grids',
  structureGridPath: '/structure_grids/:id',
  stateTaxesPath: '/state_taxes',
  areaGeometriesPath: '/area_geometries',
  areaGeometryPath: '/area_geometries/:id',
  structureGridCollectionsPath: '/structure_grid_collections',
  structureGridCollectionsDetailPath: '/structure_grid_collections/:id',
  addStructureGridCollectionsPath: '/structure_grid_collections/new',
  crmTractsAndSubtractsPath: '/crm/tracts_and_subtracts',
  crmTractWizardNewPath: '/crm/tracts_and_subtracts/new',
  crmTractWizardEditPath: '/crm/tracts_and_subtracts/:tractId/edit',
  crmBulkUploadNewPath: '/crm/tracts_and_subtracts/bulk_uploads/new',
  crmBulkUploadPath: '/crm/tracts_and_subtracts/bulk_uploads/:id',
  newDevelopmentPaceScenarioPath: '/development_pace_scenarios/new',
  newDiscountRateScenarioPath: '/discount_rate_scenarios/new',
  dcaScenariosPath: '/dca_scenarios',
  newDcaScenarioPath: '/dca_scenarios/new',
  editDcaScenarioPath: '/dca_scenarios/:id',
  typeCurveScenariosPath: '/type_curve_scenarios',
  insightsLexiconPath: '/insights_lexicon',
  insightsLexiconNewPath: '/insights_lexicon/new',
  insightsLexiconDetailsPath: '/insights_lexicon/details/:id',
  insightsLexiconEditPath: '/insights_lexicon/details/:id/edit',
  bugsFeaturesPath: '/feedback',
  bugsFeatureDetailPath: '/feedback/:id',
  notificationsPath: '/notifications',
  dcaWorkspacePath: '/dca_workspaces/:id',
  typeCurveWorkspacePath: '/type_curve_workspaces/:id',
  inventoryWorkspacePath: '/inventory_workspaces/:id',
  // dcaScenarioFormPath: '/dca_scenarios/:id',
  titleChainReconcilerPath: '/title_validator/reconciler',
  afeCatalogPath: '/afe_catalog',
  afeCatalogNewPath: '/afe_catalog/new',
  afeCatalogEditPath: '/afe_catalog/:id/edit',
  afeCatalogDetailPath: '/afe_catalog/:id',
  countyCoveragePath: '/county_coverage',
  adminPath: '/admin',
  adminDashboardPath: '/admin/dashboard',
  adminDuplicateNriCalculationsPath: '/admin/duplicate_nri_calculations',
  adminDuplicateParametersPath: '/admin/duplicate_parameters',
  adminDuplicateGeometriesPath: '/admin/duplicate_geometries',
  adminNriDiagnosticsPath: '/admin/nri_diagnostics',
  adminScheduledJobsPath: '/admin/scheduled_jobs',
  adminBlobDrainStatusPath: '/admin/blob_drain_status',
  adminBulkDumpStatusPath: '/admin/bulk_dump_status',
  adminDevelopmentAreaEvaluationOutputPath:
    '/admin/development_area_evaluation_outputs/:id',
  adminEval2RunsStatusPath: '/admin/eval2_runs_status',
  adminLegacyUnitEvaluationDownloadsPath:
    '/admin/legacy_unit_evaluation_downloads',
  adminAgentCostsPath: '/admin/agent_costs',
  adminAgentCostDetailPath: '/admin/agent_costs/agents/:agentType',
  adminUnitTypeMismatchesQueryPath: '/admin/unit_type_mismatches_query',
  adminMissingWellAssignmentsPath: '/admin/missing_well_assignments',
  adminNonIntersectingExplicitAssignmentsPath:
    '/admin/non_intersecting_explicit_assignments',
  adminUnitWellAssignmentsPath: '/admin/unit_well_assignments',
  adminAllocationManagerChecksPath: '/admin/allocation_manager_checks',
  adminSidekiqQueueAssignmentsPath: '/admin/sidekiq_queue_assignments',
  adminEmptyAllocationManagersQueryPath:
    '/admin/empty_allocation_managers_query',
  adminMissingSubtractBosPath: '/admin/missing_subtract_bos',
  adminFoucsDiagnosisPath: '/admin/foucs_diagnosis',
  adminUatsWithoutAmlisPath: '/admin/uats_without_amlis',
  adminOverAllocatedSlotsPath: '/admin/over_allocated_slots',
  adminSubtractAcreageDriftPath: '/admin/subtract_acreage_drift',
  adminSubtractsMissingTirsPath: '/admin/subtracts_missing_tirs',
  adminOrphanedSubtractGeometriesPath: '/admin/orphaned_subtract_geometries',
  adminBulkDedupePath: '/admin/bulk_dedupe',
  adminBulkDedupeRunPath: '/admin/bulk_dedupe/runs/:id',
  adminStaleRecordsAuditPath: '/admin/stale_records_audit',
  adminStaleRecordsAuditRunPath: '/admin/stale_records_audit/run',
  adminStaleRecordsAuditResultsPath:
    '/admin/stale_records_audit/results/:auditId',
  adminBosDriftAuditPath: '/admin/bos_drift_audit',
  adminBosDriftAuditRunPath: '/admin/bos_drift_audit/run',
  adminBosDriftAuditResultsPath: '/admin/bos_drift_audit/results/:auditId',
  adminProvisioningPath: '/admin/provisioning_batches',
  adminProvisioningBatchPath: '/admin/provisioning_batches/:id',
  adminProvisioningSubmissionPath:
    '/admin/provisioning_batches/:id/submissions/:submissionId',
  adminPromptManagementPath: '/admin/prompts',
  adminAutoMatchConfigurationPath: '/admin/auto_match_configuration',
  adminEntityCleanupLogPath: '/admin/entity_cleanup_logs',
  adminWellSpacingJobStatusPath: '/admin/well_spacing_job_status',
  adminInventoryAutomationStatusPath: '/admin/inventory_automation_status',
  adminIntersectionCoordinationQueuePath:
    '/admin/intersection_coordination_queue',
  adminSidekiqTimedQueuesPath: '/admin/sidekiq_timed_queues',
  mapQueryPath: '/map-query',
  forwardPriceCurvePath: '/forward_price_curve',
  pricingCurveManagementPath: '/pricing/curve-management',
  pricingCurveDetailPath: '/pricing/curve-management/:id',
  pricingContractBuilderPath: '/pricing/contract-builder',
  pricingContractDetailPath: '/pricing/contract-builder/:id',
  pricingTransformationBuilderPath: '/pricing/transformation-builder',
  pricingTransformationDetailPath: '/pricing/transformation-builder/:id',
  pricingMarketDataPath: '/pricing/market-data',
  pricingMarketDataViewPath: '/pricing/market-data/:id',
  priceDecksPath: '/price_decks',
  priceDecksNewPath: '/price_decks/new',
  priceDeckEditPath: '/price_decks/:id/edit',
  priceDeckDetailPath: '/price_decks/:id',
  developmentPaceScenariosPath: '/development_pace_scenarios',
  developmentPaceScenarioDetailPath: '/development_pace_scenarios/:id',
  divisionOrdersPath: '/division_orders',
  divisionOrderPath: '/division_orders/:id',
  divisionOrderLineItemPath: '/division_orders/:divisionOrderId/line_items/:id',
  royaltyChecksPath: '/royalty_checks',
  royaltyCheckPath: '/royalty_checks/:id',
  newTypeCurveScenarioPath: '/type_curve_scenarios/new',
  editTypeCurveScenarioPath: '/type_curve_scenarios/:id',
  discountRateScenariosPath: '/discount_rate_scenarios',
  discountRateScenarioDetailPath: '/discount_rate_scenarios/:id',
  differentialScenariosPath: '/differential_scenarios',
  newDifferentialScenarioPath: '/differential_scenarios/new',
  differentialScenarioDetailPath: '/differential_scenarios/:id',
  taxScenariosPath: '/tax_scenarios',
  newTaxScenarioPath: '/tax_scenarios/new',
  taxScenarioDetailPath: '/tax_scenarios/:id',
  evaluationCasesPath: '/evaluation_cases',
  newEvaluationCasePath: '/evaluation_cases/new',
  evaluationCaseDetailPath: '/evaluation_cases/:id',
  expenseScenariosPath: '/expense_scenarios',
  newExpenseScenarioPath: '/expense_scenarios/new',
  expenseScenarioDetailPath: '/expense_scenarios/:id',
};
